var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"smartvoiceList"},_vm._l((_vm.list),function(item){return _c('div',{key:item.groupId,staticClass:"item",class:{active: item.groupId === _vm.active},on:{"click":function($event){return _vm.setItem(item.groupId)}}},[_vm._v(" "+_vm._s(item.groupName)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }